import Alert from "@material-ui/lab/Alert";
import React from "react";

import { Snackbar } from "@material-ui/core";

import "./CommonToast.scss";

export const CommonToast = ({ open, onClose, severity, text }: any) => (
  <Snackbar
    className="common-toast"
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    open={open}
    autoHideDuration={6000}
    onClose={onClose}
  >
    <Alert onClose={onClose} severity={severity} className="alert">
      {text}
    </Alert>
  </Snackbar>
);
